module.exports = paper;